import { useTranslate } from "@refinedev/core";
import { Divider, Grid2 as Grid, Typography } from "@mui/material";

import { Form } from "@shared/components";
import {
  AgreementsAutocomplete,
  LevelsAutocomplete,
  CatalogsAutocomplete,
} from "@shared/components/AutocompleteFields";

export function BasicInformationFields() {
  const translate = useTranslate();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/agreement_admin.titles.basic_information")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("v1/agreement_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="supervisor"
          label={translate("v1/agreement_admin.fields.supervisor")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <CatalogsAutocomplete
          name="plan"
          label={translate("v1/agreement_admin.fields.plan")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <LevelsAutocomplete
          name="levels"
          label={translate("v1/agreement_admin.fields.levels")}
          multiple
          required
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="value"
          label={translate("v1/agreement_admin.fields.price")}
          mask="currency"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.DatePicker
          name="start_date"
          label={translate("v1/agreement_admin.fields.start_date")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.DatePicker
          name="received_books_start_date"
          label={translate("v1/agreement_admin.fields.received_books_start_date")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="email"
          label={translate("v1/agreement_admin.fields.email")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="site"
          label={translate("v1/agreement_admin.fields.site")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="slug_app_android"
          label={translate("v1/agreement_admin.fields.slug_app_android")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="slug_app_ios"
          label={translate("v1/agreement_admin.fields.slug_app_ios")}
        />
      </Grid>
      {/*
      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="url_app_ios"
          label={translate("v1/agreement_admin.fields.url_app_ios")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="slug_app"
          label={translate("v1/agreement_admin.fields.slug_app")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("v1/agreement_admin.fields.active")}
        />
      </Grid>
 */}
      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>
    </Grid>
  );
}
